import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { useActionData, useNavigate } from 'react-router-dom'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import AddIcon from '../../assets/AddIcon'
import ArrowDown from '../../assets/ArrowDown'
import CloseIcon from '../../assets/CloseIcon'
import EditIcon from '../../assets/EditIcon'
import TrashIcon from '../../assets/TrashIcon'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import {
  ACCOUNTING_TYPE,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import MobileHeader from '../Common/Header/MobileHeader'
import SideDrawer from '../Common/SideDrawer/SideDrawer'

import './Accounting.scss'
import DotsIcon from '../../assets/DotsIcon'
import DownloadIcon from '../../assets/DownloadIcon'
import InfoPrimary from '../../assets/infoPrimary'
import ChevronLeft from '../../assets/ChevronLeft.jsx'
import AddAccounting from './AddAccounting'
import {
  enableAccountingHelper,
  getAccountingHelper,
  getBalanceSheetStatementHelper,
  getPersonalDetailsHelper,
  getProfitLossStatementHelper,
  getReceiptPaymentHelper,
  getVoucherDetailsHelper,
  getVouchersHelper,
  updateVoucherHelper,
  getDueSalesInvoicesHelper,
  getDuePurchaseInvoicesHelper,
} from '../../helper/personal-details-helper'
import { convertToTitleCase, formatDate } from '../../common/utils/appUtils'
import PopupCard from '../Common/PopupCard/PopupCard'
import { getBranchHelper } from '../../helper/branch-management-helper'
import Config from '../../config/config'

const Accounting = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()
  const [viewDrawer, setViewDrawer] = useState(false)
  const [open, setOpen] = useState(false)
  const [activeCardId, setActiveCardId] = useState(false)
  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.ACCOUNTING,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [accountingId, setAccountingId] = useState(true)
  const [isAddAccountingActive, setIsAddAccountingActive] = useState(false)
  const [isDateFieldVisible, setIsDateFieldVisible] = useState(false)
  const [enableAcconutingData, setEnableAccountingData] = useState({
    cash_in_hand: null,
    cash_in_account: null,
    paid_up_capital: null,
    retained_earning: null,
    loan: null,
    director_loan_to_business: null,
    invoice_factoring_provider: null,
    supplier_due: null,
    other_loans: null,
    pharma: null,
    non_pharma: null,
    advances_and_deposits: null,
    loan_to_director: null,
    loan_to_account_receivable: null,
    land_and_flat_store: null,
    electrical_items: null,
    vehicles: null,
    furniture_and_fixtures: null,
    term_deposits: null,
  })
  const [shareholdersEquity, setShareholdersEquity] = useState(0)
  const [openingBalanceofLiabilities, setOpeningBalanceofLiabilities] =
    useState(0)
  const [openingBalanceofCurrentAsset, setOpeningBalanceofCurrentAsset] =
    useState(0)
  const [openingBalanceofFixedAsset, setOpeningBalanceofFixedAsset] =
    useState(0)
  const [acountingTypeActive, setAccountingTypeActive] = useState(
    ACCOUNTING_TYPE.VOUCHER_REPORT
  )
  const [isErrorFieldVisible, setIsErrorFieldVisible] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState(undefined)
  const [vouchersData, setVouchersData] = useState([])
  const [vouchersDetailsData, setVouchersDetailsData] = useState({})
  const [receiptPaymentData, setReceiptPaymentData] = useState({})
  const [profitLossData, setProfitLossData] = useState({})
  const [balanceSheetData, setBalanceSheetData] = useState({})
  const [editVoucher, setEditVoucher] = useState(false)
  const [voucherViewOnlyId, setVoucherViewOnlyId] = useState(undefined)
  const [permissions, setPermissions] = useState({})
  const [deleteVoucherPopup, setDeleteVoucherPopup] = useState(false)
  const [selectedVoucherId, setSelectedVoucherId] = useState(null)

  // Account Receivable (Due Receive) Flow States
  const [selectedReceivableItem, setSelectedReceivableItem] = useState(null) // Selected customer
  const [showReceivableInvoicePopup, setShowReceivableInvoicePopup] = useState(false)
  const [dueReceivableInvoices, setDueReceivableInvoices] = useState([])
  const [selectedReceivableInvoice, setSelectedReceivableInvoice] = useState(null)
  const [showDueReceiveOptionsPopup, setShowDueReceiveOptionsPopup] = useState(false)
  const [dueReceiveLoading, setDueReceiveLoading] = useState(false)

  // Account Payable (Due Pay) Flow States
  const [selectedPayableItem, setSelectedPayableItem] = useState(null) // Selected supplier
  const [showPayableInvoicePopup, setShowPayableInvoicePopup] = useState(false)
  const [duePayableInvoices, setDuePayableInvoices] = useState([])
  const [selectedPayableInvoice, setSelectedPayableInvoice] = useState(null)
  const [showDuePayOptionsPopup, setShowDuePayOptionsPopup] = useState(false)
  const [duePayLoading, setDuePayLoading] = useState(false)
  const [activeBranchData, setActiveBranchData] = useState(null)

  useEffect(() => {
    getAccountingId()
    getBranchHelper()
      .then((branches) => {
        const active = branches?.find((b) => b.is_active)
        if (active) {
          if (active.logo) active.logo = Config.getFullImageUrl(active.logo)
          setActiveBranchData(active)
        }
      })
      .catch(() => {})
    getPersonalDetailsHelper()
      .then((res) => {
        if (res?.logo) {
          setActiveBranchData((prev) => ({
            ...prev,
            logo: Config.getFullImageUrl(res.logo),
          }))
        }
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (!isAddAccountingActive) {
      handleHeaderConfigUpdate(HEADER_CONST.ACCOUNTING, () =>
        redirect(navigate, PAGE_CONST.HOME)
      )
      return
    }

    if (isAddAccountingActive) {
      handleHeaderConfigUpdate(HEADER_CONST.ACCOUNTING, () =>
        handleDrawerToggle()
      )
    }
  }, [isAddAccountingActive])

  useEffect(() => {
    let shareholdersEquity =
      (parseFloat(enableAcconutingData.paid_up_capital) || 0) +
      (parseFloat(enableAcconutingData.retained_earning) || 0)

    setShareholdersEquity(shareholdersEquity)
  }, [
    enableAcconutingData.paid_up_capital,
    enableAcconutingData.retained_earning,
  ])

  useEffect(() => {
    let openingBalanceofLiabilities =
      (parseFloat(enableAcconutingData.loan) || 0) +
      (parseFloat(enableAcconutingData.director_loan_to_business) || 0) +
      (parseFloat(enableAcconutingData.invoice_factoring_provider) || 0) +
      (parseFloat(enableAcconutingData.supplier_due) || 0) +
      (parseFloat(enableAcconutingData.other_loans) || 0)

    setOpeningBalanceofLiabilities(openingBalanceofLiabilities)
  }, [
    enableAcconutingData.loan,
    enableAcconutingData.director_loan_to_business,
    enableAcconutingData.invoice_factoring_provider,
    enableAcconutingData.supplier_due,
    enableAcconutingData.other_loans,
  ])

  useEffect(() => {
    let openingBalanceofCurrentAsset =
      (parseFloat(enableAcconutingData.cash_in_hand) || 0) +
      (parseFloat(enableAcconutingData.cash_in_account) || 0) +
      (parseFloat(enableAcconutingData.pharma) || 0) +
      (parseFloat(enableAcconutingData.non_pharma) || 0) +
      (parseFloat(enableAcconutingData.advances_and_deposits) || 0) +
      (parseFloat(enableAcconutingData.loan_to_director) || 0) +
      (parseFloat(enableAcconutingData.loan_to_account_receivable) || 0)

    setOpeningBalanceofCurrentAsset(openingBalanceofCurrentAsset)
  }, [
    enableAcconutingData.cash_in_hand,
    enableAcconutingData.cash_in_account,
    enableAcconutingData.pharma,
    enableAcconutingData.non_pharma,
    enableAcconutingData.advances_and_deposits,
    enableAcconutingData.loan_to_director,
    enableAcconutingData.loan_to_account_receivable,
  ])

  useEffect(() => {
    let openingBalanceofFixedAsset =
      (parseFloat(enableAcconutingData.land_and_flat_store) || 0) +
      (parseFloat(enableAcconutingData.electrical_items) || 0) +
      (parseFloat(enableAcconutingData.vehicles) || 0) +
      (parseFloat(enableAcconutingData.furniture_and_fixtures) || 0) +
      (parseFloat(enableAcconutingData.term_deposits) || 0)

    setOpeningBalanceofFixedAsset(openingBalanceofFixedAsset)
  }, [
    enableAcconutingData.land_and_flat_store,
    enableAcconutingData.electrical_items,
    enableAcconutingData.vehicles,
    enableAcconutingData.furniture_and_fixtures,
    enableAcconutingData.term_deposits,
  ])

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.OTHER
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const handleHeaderConfigUpdate = (title, handleBackFunc) => {
    setHeaderOptions({
      [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
      [HEADER_CONFIG.TITLE]: title,
      [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc(),
    })
  }

  const getAccountingId = async () => {
    try {
      let accountingData = await getAccountingHelper()
      let aId = accountingData?.id
      setAccountingId(aId)
    } catch (err) {
      console.log('err Msg: ', err)
      setAccountingId(false)
    }
  }

  const handleDrawerToggle = () => {
    setViewDrawer(!viewDrawer)
    setOpen(!open)
  }

  const getHeaderButtonText = () => {
    let buttonText = 'Save'

    if (accountingId && !isAddAccountingActive) {
      // buttonText = 'Add'
      buttonText = <AddIcon />
    }

    return buttonText
  }

  const handleEnableAccounting = async () => {
    if (
      !enableAcconutingData.cash_in_hand ||
      !enableAcconutingData.cash_in_account
    ) {
      setIsErrorFieldVisible(true)
      return
    }

    try {
      let accountingId = await enableAccountingHelper(enableAcconutingData)

      setAccountingId(accountingId)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const handleAddAccounting = () => {}

  const emptyData = () => {
    setBalanceSheetData({})
    setProfitLossData({})
    setReceiptPaymentData({})
    setVouchersData({})
  }

  const getProfitLossData = async () => {
    try {
      let pLossData = await getProfitLossStatementHelper(
        accountingId,
        startDate,
        endDate
      )

      setProfitLossData(pLossData)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const getBalanceSheetData = async () => {
    try {
      let bSheetData = await getBalanceSheetStatementHelper(
        accountingId,
        startDate,
        endDate
      )

      setBalanceSheetData(bSheetData)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const getReceiptPaymentData = async () => {
    try {
      let rData = await getReceiptPaymentHelper(
        accountingId,
        startDate,
        endDate
      )

      setReceiptPaymentData(rData)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const getVouchersData = async () => {
    try {
      let vData = await getVouchersHelper(accountingId, startDate, endDate)

      setVouchersData(vData)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const getVoucherDetails = async () => {
    try {
      let vDetailData = await getVoucherDetailsHelper(enableAcconutingData)

      setVouchersDetailsData(vDetailData)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const handleButtonClick = () => {
    if (!accountingId) {
      handleEnableAccounting()
    } else if (!isAddAccountingActive) {
      setVoucherViewOnlyId(undefined)
      setEditVoucher(undefined)
      setIsAddAccountingActive(true)
    } else {
      handleAddAccounting()
    }
  }

  const handleSubmitClick = () => {
    console.log('startDate, endDate: ', startDate, endDate)
    if (!startDate || !endDate) {
      return
    }

    getVouchersData()
    getBalanceSheetData()
    getProfitLossData()
    getReceiptPaymentData()
  }

  const handleVoucherEdit = async (id) => {
    try {
      let vDetailData = await getVoucherDetailsHelper(id)
      // handleVoucherClick(id)
      setVoucherViewOnlyId(undefined)
      setVouchersDetailsData(vDetailData)
      setEditVoucher(true)
      setIsAddAccountingActive(true)
      setActiveCardId(undefined)
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
      setActiveCardId(undefined)
    }
  }

  const handleVoucherDelete = async (id) => {
    try {
      let reqData = {
        voucher_id: id,
        type: 'DELETE',
      }

      let vId = await updateVoucherHelper(reqData)
      setActiveCardId(undefined)
      getVouchersData()
    } catch (errMsg) {
      console.log('errMsg ', errMsg)
    }
  }

  const handleVoucherClick = (id) => {
    console.log('voucher click !!')
    setIsAddAccountingActive(true)
    setVoucherViewOnlyId(id)
  }

  const [isEditMode, setIsEditMode] = useState(false)
  const [isPresentData, setIsPresentData] = useState(true)
  const reportRef = useRef(null)

  const getReportTitle = () => {
    switch (acountingTypeActive) {
      case ACCOUNTING_TYPE.RECEIPT_PAYMENT:
        return 'Receipt - Payment Statement'
      case ACCOUNTING_TYPE.PROFIT_AND_LOSS:
        return 'Profit and Loss Statement'
      case ACCOUNTING_TYPE.BALANCE_SHEET:
        return 'Balance Sheet'
      default:
        return 'Report'
    }
  }

  const formatDateDisplay = (dateStr) => {
    if (!dateStr) return ''
    const date = new Date(dateStr)
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  const downloadReportAsPDF = () => {
    // Create a temporary container for PDF content
    const pdfContainer = document.createElement('div')
    pdfContainer.style.padding = '20px'
    pdfContainer.style.backgroundColor = '#ffffff'
    pdfContainer.style.fontFamily = 'Arial, sans-serif'
    pdfContainer.style.width = '800px'

    // Add header with title and branch info
    const header = document.createElement('div')
    header.style.marginBottom = '20px'
    header.style.textAlign = 'center'
    header.innerHTML = `
      <h2 style="margin: 0 0 10px 0; color: #333;">${getReportTitle()}</h2>
      <div style="display: flex; align-items: flex-start; gap: 10px; margin-bottom: 10px; padding-bottom: 10px; border-bottom: 1px solid #000; text-align: left;">
        ${activeBranchData?.logo ? `<img src="${activeBranchData.logo}" alt="logo" style="width: 45px; height: 45px; object-fit: contain;" crossorigin="anonymous" />` : ''}
        <div style="flex: 1;">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="font-size: 14px; font-weight: bold;">${props.loginData?.pharmacy_name || activeBranchData?.pharmacy_name || ''}${activeBranchData?.name ? ` (${activeBranchData.name})` : ''}</span>
            <span style="font-size: 11px;">📞 ${activeBranchData?.mobile_no || ''}</span>
          </div>
          <div style="font-size: 10px; margin-top: 3px;">📍 ${activeBranchData?.address || activeBranchData?.location || ''}</div>
        </div>
      </div>
      <p style="margin: 0; color: #666; font-size: 14px;">
        Period: ${formatDateDisplay(startDate)} - ${formatDateDisplay(endDate)}
      </p>
    `
    pdfContainer.appendChild(header)

    // Build filtered report content based on active tab
    const reportContent = document.createElement('div')
    
    if (acountingTypeActive === ACCOUNTING_TYPE.RECEIPT_PAYMENT && receiptPaymentData?.hasOwnProperty('total_payments')) {
      reportContent.innerHTML = buildReceiptPaymentHTML()
    } else if (acountingTypeActive === ACCOUNTING_TYPE.PROFIT_AND_LOSS && profitLossData?.hasOwnProperty('debit_total')) {
      reportContent.innerHTML = buildProfitLossHTML()
    } else if (acountingTypeActive === ACCOUNTING_TYPE.BALANCE_SHEET && balanceSheetData?.total_shareholders_equity !== undefined) {
      reportContent.innerHTML = buildBalanceSheetHTML()
    }

    pdfContainer.appendChild(reportContent)
    document.body.appendChild(pdfContainer)

    html2canvas(pdfContainer, {
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      scale: window.devicePixelRatio * 2,
    }).then((canvas) => {
      const paddedCanvas = document.createElement('canvas')
      const context = paddedCanvas.getContext('2d')
      const padding = 30
      paddedCanvas.width = canvas.width + 2 * padding
      paddedCanvas.height = canvas.height + 2 * padding
      context.fillStyle = '#ffffff'
      context.fillRect(0, 0, paddedCanvas.width, paddedCanvas.height)
      context.drawImage(canvas, padding, padding)

      const dataURL = paddedCanvas.toDataURL('image/png')
      const pdf = new jsPDF('p', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width

      // Handle multiple pages if content is too long
      if (pdfHeight > pdf.internal.pageSize.getHeight()) {
        const pageHeight = pdf.internal.pageSize.getHeight()
        let position = 0
        let remainingHeight = pdfHeight

        while (remainingHeight > 0) {
          pdf.addImage(dataURL, 'PNG', 0, position, pdfWidth, pdfHeight)
          remainingHeight -= pageHeight
          if (remainingHeight > 0) {
            pdf.addPage()
            position -= pageHeight
          }
        }
      } else {
        pdf.addImage(dataURL, 'PNG', 0, 0, pdfWidth, pdfHeight)
      }

      const fileName = `${getReportTitle().replace(/\s+/g, '_')}_${startDate}_to_${endDate}.pdf`
      pdf.save(fileName)
      document.body.removeChild(pdfContainer)
    })
  }

  const hasValue = (value) => {
    return value !== undefined && value !== null && value !== 0 && value !== '0' && value !== ''
  }

  const buildTableRow = (label, value, isHeader = false, isSubItem = false) => {
    if (!hasValue(value) && !isHeader) return ''
    const bgColor = isHeader ? '#f5f0eb' : '#ffffff'
    const fontWeight = isHeader ? 'bold' : 'normal'
    const color = isHeader ? '#e07c3e' : '#333'
    const paddingLeft = isSubItem ? '20px' : '10px'
    return `
      <tr style="background-color: ${bgColor};">
        <td style="padding: 8px 10px 8px ${paddingLeft}; border-bottom: 1px solid #eee; font-weight: ${fontWeight}; color: ${color};">${label}</td>
        <td style="padding: 8px 10px; border-bottom: 1px solid #eee; text-align: right; font-weight: ${fontWeight}; color: ${color};">BDT ${value}</td>
      </tr>
    `
  }

  const buildReceiptPaymentHTML = () => {
    let receiptRows = ''
    let paymentRows = ''

    // Receipt section
    // Opening Balance
    if (hasValue(receiptPaymentData.opening_balance) || hasValue(receiptPaymentData.opening_cash_in_account) || hasValue(receiptPaymentData.opening_cash_in_hand)) {
      receiptRows += buildTableRow('Opening Balance', receiptPaymentData.opening_balance, true)
      receiptRows += buildTableRow('Cash in A/C', receiptPaymentData.opening_cash_in_account, false, true)
      receiptRows += buildTableRow('Cash-in-Hand', receiptPaymentData.opening_cash_in_hand, false, true)
    }

    // Liabilities
    if (hasValue(receiptPaymentData.total_liabilities_credit)) {
      receiptRows += buildTableRow('Liabilities', receiptPaymentData.total_liabilities_credit, true)
      receiptRows += buildTableRow('Loan', receiptPaymentData.loan_credit, false, true)
      receiptRows += buildTableRow("Director/Proprietor's Loan to business", receiptPaymentData.director_loan_to_business_credit, false, true)
      receiptRows += buildTableRow('Invoice Factoring Provider', receiptPaymentData.invoice_factoring_provider_credit, false, true)
      receiptRows += buildTableRow("Supplier's Due / Account Payable", receiptPaymentData.supplier_due_credit, false, true)
      receiptRows += buildTableRow('Other Loans/Due', receiptPaymentData.other_loans_due_credit, false, true)
    }

    // Current Assets
    if (hasValue(receiptPaymentData.total_current_assets_credit)) {
      receiptRows += buildTableRow('Current Assets', receiptPaymentData.total_current_assets_credit, true)
      receiptRows += buildTableRow('Advances / Deposits', receiptPaymentData.advances_deposits_credit, false, true)
      receiptRows += buildTableRow('Loan to Director/Proprietor', receiptPaymentData.loan_to_director_credit, false, true)
      receiptRows += buildTableRow('Account Receivables', receiptPaymentData.account_receivables_credit, false, true)
    }

    // Sales
    if (hasValue(receiptPaymentData.total_sales)) {
      receiptRows += buildTableRow('Sales', receiptPaymentData.total_sales, true)
      receiptRows += buildTableRow('Pharma Product Sales', receiptPaymentData.actual_price_of_pharma_products_sold, false, true)
      receiptRows += buildTableRow('Non-Pharma Product Sales', receiptPaymentData.actual_price_of_non_pharma_products_sold, false, true)
      receiptRows += buildTableRow('Expired Product Return Loss', receiptPaymentData.expired_product_return_loss, false, true)
      receiptRows += buildTableRow('Damage/lost Loss', receiptPaymentData.damage_lost_loss, false, true)
    }

    // Fixed Assets
    if (hasValue(receiptPaymentData.total_fixed_assets_credit)) {
      receiptRows += buildTableRow('Fixed Assets', receiptPaymentData.total_fixed_assets_credit, true)
      receiptRows += buildTableRow('Land & Flat/Store', receiptPaymentData.land_and_flat_store_credit, false, true)
      receiptRows += buildTableRow('Electrical/Electronic Items', receiptPaymentData.electrical_items_credit, false, true)
      receiptRows += buildTableRow('Vehicles', receiptPaymentData.vehicles_credit, false, true)
      receiptRows += buildTableRow('Furniture & Fixtures', receiptPaymentData.furniture_and_fixtures_credit, false, true)
      receiptRows += buildTableRow('Term Deposits', receiptPaymentData.term_deposits_credit, false, true)
    }

    // Shareholder's Equity
    if (hasValue(receiptPaymentData.shareholders_equity_credit)) {
      receiptRows += buildTableRow("Shareholder's Equity", receiptPaymentData.shareholders_equity_credit, true)
      receiptRows += buildTableRow('Paid up capital', receiptPaymentData.paid_up_capital, false, true)
    }

    // Payment section
    // Current Assets
    if (hasValue(receiptPaymentData.total_current_assets_debit)) {
      paymentRows += buildTableRow('Current Assets', receiptPaymentData.total_current_assets_debit, true)
      paymentRows += buildTableRow('Advances / Deposits', receiptPaymentData.advances_deposits_debit, false, true)
      paymentRows += buildTableRow('Loan to Director/Proprietor', receiptPaymentData.loan_to_director_debit, false, true)
      paymentRows += buildTableRow('Account Receivables', receiptPaymentData.account_receivables_debit, false, true)
    }

    // Fixed Assets
    if (hasValue(receiptPaymentData.total_fixed_assets_debit)) {
      paymentRows += buildTableRow('Fixed Assets', receiptPaymentData.total_fixed_assets_debit, true)
      paymentRows += buildTableRow('Land & Flat/Store', receiptPaymentData.land_and_flat_store_debit, false, true)
      paymentRows += buildTableRow('Electrical/Electronic Items', receiptPaymentData.electrical_items_debit, false, true)
      paymentRows += buildTableRow('Vehicles', receiptPaymentData.vehicles_debit, false, true)
      paymentRows += buildTableRow('Furniture & Fixtures', receiptPaymentData.furniture_and_fixtures_debit, false, true)
      paymentRows += buildTableRow('Term Deposits', receiptPaymentData.term_deposits_debit, false, true)
    }

    // Shareholder's Equity
    if (hasValue(receiptPaymentData.shareholders_equity_debit)) {
      paymentRows += buildTableRow("Shareholder's Equity", receiptPaymentData.shareholders_equity_debit, true)
      paymentRows += buildTableRow('Withdrawals / Dividend to Shareholders', receiptPaymentData.dividend_to_shareholders, false, true)
    }

    // Liabilities
    if (hasValue(receiptPaymentData.total_liabilities_debit)) {
      paymentRows += buildTableRow('Liabilities', receiptPaymentData.total_liabilities_debit, true)
      paymentRows += buildTableRow('Loan', receiptPaymentData.loan_debit, false, true)
      paymentRows += buildTableRow("Director/Proprietor's Loan to business", receiptPaymentData.director_loan_to_business_debit, false, true)
      paymentRows += buildTableRow('Invoice Factoring Provider', receiptPaymentData.invoice_factoring_provider_debit, false, true)
      paymentRows += buildTableRow("Supplier's Due / Account Payable", receiptPaymentData.supplier_due_debit, false, true)
      paymentRows += buildTableRow('Other Loans/Due', receiptPaymentData.other_loans_due_debit, false, true)
    }

    // Purchase/ Direct Expense
    if (hasValue(receiptPaymentData.total_purchase_amount)) {
      paymentRows += buildTableRow('Purchase/ Direct Expense', receiptPaymentData.total_purchase_amount, true)
      paymentRows += buildTableRow('Pharma Product Purchase', receiptPaymentData.total_pharma_purchase, false, true)
      paymentRows += buildTableRow('Non-Pharma Product Purchase', receiptPaymentData.total_non_pharma_purchase, false, true)
    }

    // Indirect expenses
    if (hasValue(receiptPaymentData.indirect_expenses)) {
      paymentRows += buildTableRow('Indirect expenses', receiptPaymentData.indirect_expenses, true)
      paymentRows += buildTableRow('Salary & Allowances', receiptPaymentData.total_salary_expenses, false, true)
      paymentRows += buildTableRow("Owner's Allowance", receiptPaymentData.owners_allowance, false, true)
      paymentRows += buildTableRow('Staff Salary', receiptPaymentData.staff_salary, false, true)
      paymentRows += buildTableRow('Stuff Allowance', receiptPaymentData.stuff_allowance, false, true)
      paymentRows += buildTableRow('Festival Bonus', receiptPaymentData.festival_bonus, false, true)
      paymentRows += buildTableRow('General Expenses', receiptPaymentData.total_general_expenses, false, true)
      paymentRows += buildTableRow('Shop/Store Rent', receiptPaymentData.shop_store_rent, false, true)
      paymentRows += buildTableRow('Platform Expense', receiptPaymentData.platform_expense, false, true)
      paymentRows += buildTableRow('Delivery Expense', receiptPaymentData.delivery_expense, false, true)
      paymentRows += buildTableRow('Income TAX paid to govt.', receiptPaymentData.income_tax_paid_to_govt, false, true)
      paymentRows += buildTableRow('VAT paid to govt.', receiptPaymentData.vat_paid_to_govt, false, true)
      paymentRows += buildTableRow('Electricity Bill', receiptPaymentData.electricity_bill, false, true)
      paymentRows += buildTableRow('Water Bill', receiptPaymentData.water_bill, false, true)
      paymentRows += buildTableRow('Connectivity Bill', receiptPaymentData.connectivity_bill, false, true)
      paymentRows += buildTableRow('BCDS monthly Fee', receiptPaymentData.bcds_monthly_fee, false, true)
      paymentRows += buildTableRow('Entertainment', receiptPaymentData.entertainment, false, true)
      paymentRows += buildTableRow('Travel / Conveyance', receiptPaymentData.travel_conveyance, false, true)
      paymentRows += buildTableRow('Stationary / Computer Accessories', receiptPaymentData.stationary_computer_accessories, false, true)
      paymentRows += buildTableRow('Licencing & renewal fee', receiptPaymentData.licencing_renewal_fee, false, true)
      paymentRows += buildTableRow('Expired Product Return Loss', receiptPaymentData.expired_product_return_loss, false, true)
      paymentRows += buildTableRow('Damage/lost Loss', receiptPaymentData.damage_lost_loss, false, true)
      paymentRows += buildTableRow('Depreciation', receiptPaymentData.depreciation, false, true)
      paymentRows += buildTableRow('POS machine charge', receiptPaymentData.pos_machine_charge, false, true)
      paymentRows += buildTableRow('Interest Expense', receiptPaymentData.interest_expense, false, true)
      paymentRows += buildTableRow('Bank charges', receiptPaymentData.bank_charges, false, true)
      paymentRows += buildTableRow('Legal Charge & Fees', receiptPaymentData.legal_charge_fees, false, true)
      paymentRows += buildTableRow('Audit and Tax Consultancy', receiptPaymentData.audit_and_tax_consultancy, false, true)
      paymentRows += buildTableRow('Marketing/Advertising Expenses', receiptPaymentData.marketing_advertising_expenses, false, true)
      paymentRows += buildTableRow('Miscellaneous', receiptPaymentData.miscellaneous, false, true)
    }

    return `
      <div style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Receipt</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${receiptRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${receiptPaymentData.total_credit}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Payment</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${paymentRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total Payments</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${receiptPaymentData.total_payments}</td>
              </tr>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px;">Closing Balance</td>
                <td style="padding: 8px 10px; text-align: right;">BDT ${receiptPaymentData.closing_balance}</td>
              </tr>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${receiptPaymentData.total_debit}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    `
  }

  const buildProfitLossHTML = () => {
    let debitRows = ''
    let creditRows = ''

    // Debit section
    // Opening Stock
    if (hasValue(profitLossData.total_opening_stock)) {
      debitRows += buildTableRow('Opening Stock (Inventory)', profitLossData.total_opening_stock, true)
      debitRows += buildTableRow('Pharma Product', profitLossData.opening_pharma_stock, false, true)
      debitRows += buildTableRow('Non-Pharma Product', profitLossData.opening_non_pharma_stock, false, true)
    }

    // Purchase Account
    if (hasValue(profitLossData.total_purchase_amount)) {
      debitRows += buildTableRow('Purchase Account', profitLossData.total_purchase_amount, true)
      debitRows += buildTableRow('Pharma Product', profitLossData.total_pharma_purchase, false, true)
      debitRows += buildTableRow('Non-Pharma Product', profitLossData.total_non_pharma_purchase, false, true)
    }

    // Cost of Products Sold
    if (hasValue(profitLossData.cost_of_products_sold)) {
      debitRows += buildTableRow('Cost of Products Sold (COPS)', profitLossData.cost_of_products_sold, true)
      debitRows += buildTableRow('Pharma Product', profitLossData.cost_of_pharma_products_sold, false, true)
      debitRows += buildTableRow('Non-Pharma Product', profitLossData.cost_of_non_pharma_products_sold, false, true)
    }

    // Indirect Expenses
    if (hasValue(profitLossData.indirect_expenses)) {
      debitRows += buildTableRow('Indirect Expenses', profitLossData.indirect_expenses, true)
      debitRows += buildTableRow('Salary & Allowances', profitLossData.salary_allowances, false, true)
      debitRows += buildTableRow('General Expenses', profitLossData.general_expenses, false, true)
    }

    // Credit section
    // Sales Account
    if (hasValue(profitLossData.sales_account)) {
      creditRows += buildTableRow('Sales Account', profitLossData.sales_account, true)
      creditRows += buildTableRow('Pharma Product', profitLossData.actual_price_of_pharma_products_sold, false, true)
      creditRows += buildTableRow('Non-Pharma Product', profitLossData.actual_price_of_non_pharma_products_sold, false, true)
    }

    // Closing Stock
    if (hasValue(profitLossData.total_closing_stock)) {
      creditRows += buildTableRow('Closing Stock (Inventory)', profitLossData.total_closing_stock, true)
      creditRows += buildTableRow('Pharma Product', profitLossData.closing_pharma_stock, false, true)
      creditRows += buildTableRow('Non-Pharma Product', profitLossData.closing_non_pharma_stock, false, true)
    }

    // Gross Profit
    if (hasValue(profitLossData.gross_profit)) {
      creditRows += buildTableRow('Gross Profit', profitLossData.gross_profit, true)
      creditRows += buildTableRow('Pharma Product', profitLossData.pharma_product_profit, false, true)
      creditRows += buildTableRow('Non-Pharma Product', profitLossData.non_pharma_product_profit, false, true)
      creditRows += buildTableRow('Others', profitLossData.gross_profit_others, false, true)
    }

    // Net Profit / Loss
    if (hasValue(profitLossData.net_profit_and_loss)) {
      creditRows += buildTableRow('Net Profit / Loss', profitLossData.net_profit_and_loss, true)
    }

    return `
      <div style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Debit/Payments</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${debitRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${profitLossData.debit_total}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Credits/Sales</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${creditRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${profitLossData.credit_total}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    `
  }

  const buildBalanceSheetHTML = () => {
    let liabilitiesRows = ''
    let assetsRows = ''

    // Liabilities & Owner's Equity section
    // Shareholders' Equity
    if (hasValue(balanceSheetData.total_shareholders_equity)) {
      liabilitiesRows += buildTableRow("Shareholders' Equity", balanceSheetData.total_shareholders_equity, true)
      liabilitiesRows += buildTableRow('Paid up Capital', balanceSheetData.paid_up_capital, false, true)
      liabilitiesRows += buildTableRow('Retained Earning', balanceSheetData.retained_earning_total, false, true)
      liabilitiesRows += buildTableRow('Retained Earning (Beginning Balance)', balanceSheetData.retained_earning, false, true)
      liabilitiesRows += buildTableRow('Current year profit', balanceSheetData.current_year_profit, false, true)
      liabilitiesRows += buildTableRow('Withdrawals / Dividend to Shareholders', balanceSheetData.dividend_to_shareholders, false, true)
    }

    // Liabilities
    if (hasValue(balanceSheetData.liabilities_total)) {
      liabilitiesRows += buildTableRow('Liabilities', balanceSheetData.liabilities_total, true)
      liabilitiesRows += buildTableRow('Loan', balanceSheetData.loan, false, true)
      liabilitiesRows += buildTableRow("Director/Proprietor's Loan to business", balanceSheetData.director_loan_to_business, false, true)
      liabilitiesRows += buildTableRow('Invoice Factoring Provider', balanceSheetData.invoice_factoring_provider, false, true)
      liabilitiesRows += buildTableRow("Supplier's Due/Account Payable", balanceSheetData.supplier_due, false, true)
      liabilitiesRows += buildTableRow('Other Loans/Due', balanceSheetData.other_loans_due, false, true)
    }

    // Assets section
    // Current Assets
    if (hasValue(balanceSheetData.total_current_assets)) {
      assetsRows += buildTableRow('Current Assets', balanceSheetData.total_current_assets, true)
      assetsRows += buildTableRow('Cash in Hand', balanceSheetData.cash_in_hand, false, true)
      assetsRows += buildTableRow('Cash in Bank', balanceSheetData.cash_in_account, false, true)
      assetsRows += buildTableRow('Inventory', balanceSheetData.total_inventory, false, true)
      assetsRows += buildTableRow('Pharma products', balanceSheetData.pharma_products, false, true)
      assetsRows += buildTableRow('Non-Pharma products', balanceSheetData.non_pharma_products, false, true)
      assetsRows += buildTableRow('Advances / Deposits', balanceSheetData.advances_deposits, false, true)
      assetsRows += buildTableRow('Loan to Director/Proprietor', balanceSheetData.loan_to_director, false, true)
      assetsRows += buildTableRow('Account Receivables', balanceSheetData.account_receivables, false, true)
    }

    // Fixed Assets
    if (hasValue(balanceSheetData.total_fixed_assets)) {
      assetsRows += buildTableRow('Fixed Assets', balanceSheetData.total_fixed_assets, true)
      assetsRows += buildTableRow('Land & Flat/Store', balanceSheetData.land_and_flat_store, false, true)
      assetsRows += buildTableRow('Electrical/Electronic Items', balanceSheetData.electrical_items, false, true)
      assetsRows += buildTableRow('Vehicles', balanceSheetData.vehicles, false, true)
      assetsRows += buildTableRow('Furniture & Fixtures', balanceSheetData.furniture_and_fixtures, false, true)
      assetsRows += buildTableRow('Term Deposits', balanceSheetData.term_deposits, false, true)
    }

    return `
      <div style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Liabilities & Owner's Equity</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${liabilitiesRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${balanceSheetData.total_liabilities}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div style="flex: 1;">
          <h3 style="color: #e07c3e; margin-bottom: 10px;">Assets</h3>
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 8px 10px; text-align: left; border-bottom: 2px solid #ddd;">Description</th>
                <th style="padding: 8px 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>${assetsRows}</tbody>
            <tfoot>
              <tr style="background-color: #f5f5f5; font-weight: bold;">
                <td style="padding: 8px 10px; border-top: 2px solid #ddd;">Total</td>
                <td style="padding: 8px 10px; text-align: right; border-top: 2px solid #ddd;">BDT ${balanceSheetData.total_assets}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    `
  }

  const canDownloadReport = () => {
    if (acountingTypeActive === ACCOUNTING_TYPE.RECEIPT_PAYMENT && receiptPaymentData?.hasOwnProperty('total_payments')) {
      return true
    }
    if (acountingTypeActive === ACCOUNTING_TYPE.PROFIT_AND_LOSS && profitLossData?.hasOwnProperty('debit_total')) {
      return true
    }
    if (acountingTypeActive === ACCOUNTING_TYPE.BALANCE_SHEET && balanceSheetData?.total_shareholders_equity !== undefined) {
      return true
    }
    return false
  }

  const backToCurrentDataHandler = () => {
    setIsPresentData(true)
    setIsEditMode(false)
  }

  // Account Receivable (Due Receive) Flow Handlers
  const handleReceivableItemClick = async (item) => {
    setSelectedReceivableItem(item)
    setDueReceiveLoading(true)
    setShowReceivableInvoicePopup(true)
    
    // Call backend API to get actual invoices for this customer
    // Check multiple possible field names for customer ID
    const customerId = item.customer_id || item.customerId || item.id
    if (!customerId) {
      console.warn('No customer ID found in item:', item)
      setDueReceivableInvoices([])
      setDueReceiveLoading(false)
      return
    }
    const invoices = await getDueSalesInvoicesHelper(customerId, startDate, endDate)
    setDueReceivableInvoices(invoices || [])
    setDueReceiveLoading(false)
  }

  const handleDueReceiveClick = (invoice) => {
    setSelectedReceivableInvoice(invoice)
    setShowDueReceiveOptionsPopup(true)
  }

  const handleReceiveOnline = async () => {
    setDueReceiveLoading(true)
    // When backend is ready, call the receive online API
    alert('Receive Online feature will be available once backend API is ready. This will redirect to payment gateway.')
    setDueReceiveLoading(false)
    setShowDueReceiveOptionsPopup(false)
  }

  const handleVoucherReceive = () => {
    // Navigate to AddAccounting with pre-filled data for receiving payment
    setShowDueReceiveOptionsPopup(false)
    setShowReceivableInvoicePopup(false)
    
    // Set voucher details with pre-filled data for due receive
    const prefilledVoucherData = {
      category: 'CURRENT_ASSETS',
      is_due_receive: true, // Flag to identify this is a due receive voucher
      due_invoice_id: selectedReceivableInvoice?.id || null,
      due_invoice_number: selectedReceivableInvoice?.invoice_number || null,
      customer_id: selectedReceivableItem?.customer_id || selectedReceivableItem?.id || null,
      voucher_details: [
        {
          sub_category: 'ACCOUNT_RECEIVABLES',
          particulars: `Due Receive - ${selectedReceivableItem?.name || selectedReceivableItem?.customer_name || ''} (${selectedReceivableInvoice?.invoice_number || ''})`,
          payment_mode: '',
          credit: selectedReceivableInvoice?.total_amount || 0,
          debit: 0,
        }
      ]
    }
    setVouchersDetailsData(prefilledVoucherData)
    setEditVoucher(false)
    setVoucherViewOnlyId(undefined)
    setIsAddAccountingActive(true)
  }

  const closeReceivableInvoicePopup = () => {
    setShowReceivableInvoicePopup(false)
    setSelectedReceivableItem(null)
    setDueReceivableInvoices([])
  }

  const closeDueReceiveOptionsPopup = () => {
    setShowDueReceiveOptionsPopup(false)
    setSelectedReceivableInvoice(null)
  }

  // Account Payable (Due Pay) Flow Handlers
  const handlePayableItemClick = async (item) => {
    setSelectedPayableItem(item)
    setDuePayLoading(true)
    setShowPayableInvoicePopup(true)
    
    // Call backend API to get actual invoices for this supplier
    // Check multiple possible field names for supplier ID
    const supplierId = item.supplier_id || item.supplierId || item.id
    if (!supplierId) {
      console.warn('No supplier ID found in item:', item)
      setDuePayableInvoices([])
      setDuePayLoading(false)
      return
    }
    const invoices = await getDuePurchaseInvoicesHelper(supplierId, startDate, endDate)
    setDuePayableInvoices(invoices || [])
    setDuePayLoading(false)
  }

  const handleDuePayClick = (invoice) => {
    setSelectedPayableInvoice(invoice)
    setShowDuePayOptionsPopup(true)
  }

  const handlePayOnline = async () => {
    setDuePayLoading(true)
    // When backend is ready, call the pay online API
    alert('Pay Online feature will be available once backend API is ready. This will redirect to payment gateway.')
    setDuePayLoading(false)
    setShowDuePayOptionsPopup(false)
  }

  const handleVoucherPayment = () => {
    // Navigate to AddAccounting with pre-filled data for paying supplier
    setShowDuePayOptionsPopup(false)
    setShowPayableInvoicePopup(false)
    
    // Set voucher details with pre-filled data for due payment
    const prefilledVoucherData = {
      category: 'CURRENT_LIABILITIES',
      is_due_payment: true, // Flag to identify this is a due payment voucher
      due_invoice_id: selectedPayableInvoice?.id || null,
      due_invoice_number: selectedPayableInvoice?.invoice_number || null,
      supplier_id: selectedPayableItem?.supplier_id || selectedPayableItem?.id || null,
      voucher_details: [
        {
          sub_category: 'ACCOUNT_PAYABLES',
          particulars: `Due Payment - ${selectedPayableItem?.name || selectedPayableItem?.supplier_name || ''} (${selectedPayableInvoice?.invoice_number || ''})`,
          payment_mode: '',
          credit: 0,
          debit: selectedPayableInvoice?.total_amount || 0,
        }
      ]
    }
    setVouchersDetailsData(prefilledVoucherData)
    setEditVoucher(false)
    setVoucherViewOnlyId(undefined)
    setIsAddAccountingActive(true)
  }

  const closePayableInvoicePopup = () => {
    setShowPayableInvoicePopup(false)
    setSelectedPayableItem(null)
    setDuePayableInvoices([])
  }

  const closeDuePayOptionsPopup = () => {
    setShowDuePayOptionsPopup(false)
    setSelectedPayableInvoice(null)
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {!isAddAccountingActive && (
        <div className="pageBodyRightPanel accounting">
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
            {!isMobile && (
              <div className="pageBodyRightPanelHeading">Accounting</div>
            )}
            <div className="chooseTimeline dFlex aiCenter">
              <div className="formInline dFlex">
                {accountingId && !isAddAccountingActive && (
                  <>
                    <div className="formGroup formFloating mb-0 flex1">
                      <input
                        type="date"
                        className="formControl"
                        id="email"
                        placeholder="From"
                        value={startDate}
                        onChange={(event) => {
                          console.log(event.target.value)

                          emptyData()
                          setStartDate(event.target.value)
                        }}
                        required
                      />
                      <label for="address">From</label>
                    </div>
                    <div className="formGroup formFloating ml-4 mb-0 flex1">
                      <input
                        type="date"
                        className="formControl"
                        id="email"
                        placeholder="To"
                        value={endDate}
                        onChange={(event) => {
                          console.log(event.target.value)
                          emptyData()
                          setEndDate(event.target.value)
                        }}
                        required
                      />
                      <label for="address">To</label>
                    </div>
                    <div
                      className={`dFlex ${
                        !isMobile ? 'ml-4' : 'mt-5 flexBreak50'
                      }`}
                    >
                      <button
                        className="btn btnPrimary flexBreak"
                        onClick={() => handleSubmitClick()}
                      >
                        SUBMIT
                      </button>
                    </div>
                  </>
                )}
                {permissions?.features?.[PERMISSION_FEATURE.ACCOUNTING] ===
                  PERMISSION_TYPE.MANAGE && (
                  <div className={`dFlex ml-4 ${isMobile && 'mt-5'}`}>
                    <button
                      className="btn btnPrimary"
                      onClick={() => handleButtonClick()}
                    >
                      {getHeaderButtonText()}
                    </button>
                  </div>
                )}
                {canDownloadReport() && acountingTypeActive !== ACCOUNTING_TYPE.VOUCHER_REPORT && (
                  <div
                    className={`dFlex ${
                      !isMobile ? 'ml-4' : 'mt-5 flexBreak50'
                    }`}
                  >
                    <button
                      className="btn btnPrimary flexBreak"
                      onClick={() => downloadReportAsPDF()}
                      title="Download Report"
                    >
                      <DownloadIcon />
                    </button>
                  </div>
                )}
              </div>
              {/* {!isMobile && (
                                <div className="pointer ml-4">
                                    <CloseIcon />
                                </div>
                            )} */}
            </div>
          </div>
          {!accountingId && (
            <div className="accountingMainScreen">
              <div className="semiHeading mb-4">
                Please declare following details to enable accounting. The
                fields marked in '*' are mandatory
              </div>
              <div className="">
                <div className="formInline accountingForm">
                  <div className="dFlex">
                    <div className="accountingHalf">
                      <div className="accountingFormSection">
                        <div className="accountingFormSectionBar">
                          <div className="accountingFormSectionBarHeading">
                            Shareholders Equity
                          </div>
                          <div className="accountingFormSectionBarConclude">
                            {`BDT ${shareholdersEquity || 0}`}
                          </div>
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Paid up Capital"
                            value={enableAcconutingData.paid_up_capital}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                paid_up_capital: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Paid up Capital</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Paid up Capital.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Retained Earning (Beginning Balance)"
                            value={enableAcconutingData.retained_earning}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                retained_earning: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Retained Earning (Beginning Balance)
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Retained Earning (Beginning Balance).
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="accountingFormSection">
                        <div className="accountingFormSectionBar">
                          <div className="accountingFormSectionBarHeading">
                            Opening Balance of Liabilities
                          </div>
                          <div className="accountingFormSectionBarConclude">
                            {`BDT ${openingBalanceofLiabilities || 0}`}
                          </div>
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Loan"
                            value={enableAcconutingData.loan}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                loan: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Loan</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Loan.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Director's/Proprietor’s loan to Business"
                            value={
                              enableAcconutingData.director_loan_to_business
                            }
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                director_loan_to_business: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Director's/Proprietor’s loan to Business
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Director's/Proprietor’s loan to
                              Business.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Invoice Factoring Provider"
                            value={
                              enableAcconutingData.invoice_factoring_provider
                            }
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                invoice_factoring_provider: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Invoice Factoring Provider
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Invoice Factoring Provider.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Suppliers Due/Account Payable"
                            requvalue={enableAcconutingData.supplier_due}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                supplier_due: event.target.value,
                              })
                            }}
                            ired
                          />
                          <label for="address">
                            Suppliers Due/Account Payable
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Suppliers Due/Account Payable.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Other Loans/Dues"
                            value={enableAcconutingData.other_loans}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                other_loans: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Other Loans/Dues</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Other Loans/Dues.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="accountingHalf">
                      <div className="accountingFormSection">
                        <div className="accountingFormSectionBar">
                          <div className="accountingFormSectionBarHeading">
                            Opening Balance of Current Asset
                          </div>
                          <div className="accountingFormSectionBarConclude">
                            {`BDT ${openingBalanceofCurrentAsset || 0}`}
                          </div>
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Cash in Hand"
                            required
                            value={enableAcconutingData.cash_in_hand}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                cash_in_hand: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Cash in Hand
                            <sup className="textPrimary">*</sup>
                          </label>
                          {isErrorFieldVisible &&
                            !enableAcconutingData.cash_in_hand && (
                              <div className="invalidFeedback">
                                Please enter CIH (Cash in Hand).
                              </div>
                            )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Cash in Bank"
                            required
                            value={enableAcconutingData.cash_in_account}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                cash_in_account: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Cash in Bank
                            <sup className="textPrimary">*</sup>
                          </label>
                          {isErrorFieldVisible &&
                            !enableAcconutingData.cash_in_account && (
                              <div className="invalidFeedback">
                                Please enter Cash in Bank.
                              </div>
                            )}
                        </div>
                        <div className="accountingFormSectionBar insideHead">
                          <div className="accountingFormSectionBarHeading">
                            Inventory
                          </div>
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Pharma Products"
                            value={enableAcconutingData.pharma}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                pharma: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Pharma Products</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Pharma Products.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Non-Pharma Products"
                            value={enableAcconutingData.non_pharma}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                non_pharma: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Non-Pharma Products</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Non-Pharma Products.
                            </div>
                          )}
                        </div>
                        <div className="accountingFormSectionBar insideHead">
                          <hr />
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Advances and Deposits"
                            value={enableAcconutingData.advances_and_deposits}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                advances_and_deposits: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Advances and Deposits</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Advances and Deposits.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Loan to Director/Proprietor"
                            value={enableAcconutingData.loan_to_director}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                loan_to_director: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Loan to Director/Proprietor
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Loan to Director/Proprietor.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Loan to Account Receivable"
                            value={
                              enableAcconutingData.loan_to_account_receivable
                            }
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                loan_to_account_receivable: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Loan to Account Receivable
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Loan to Account Receivable.
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="accountingFormSection">
                        <div className="accountingFormSectionBar">
                          <div className="accountingFormSectionBarHeading">
                            Opening Balance of Fixed Asset
                          </div>
                          <div className="accountingFormSectionBarConclude">
                            {`BDT ${openingBalanceofFixedAsset || 0}`}
                          </div>
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Land and Flat/Store"
                            value={enableAcconutingData.land_and_flat_store}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                land_and_flat_store: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Land and Flat/Store</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Land and Flat/Store.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Electrical/Electronic Items"
                            value={enableAcconutingData.electrical_items}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                electrical_items: event.target.value,
                              })
                            }}
                          />
                          <label for="address">
                            Electrical/Electronic Items
                          </label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Electrical/Electronic Items.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Vehicles"
                            value={enableAcconutingData.vehicles}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                vehicles: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Vehicles</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Vehicles.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Furniture and Fixtures"
                            value={enableAcconutingData.furniture_and_fixtures}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                furniture_and_fixtures: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Furniture and Fixtures</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Furniture and Fixtures.
                            </div>
                          )}
                        </div>
                        <div className="formGroup formFloating formInputText">
                          <div className="preInputGroup backColor">
                            <div className="preInputText">BDT</div>
                          </div>
                          <input
                            type="text"
                            className="formControl"
                            id="email"
                            placeholder="Term Deposits"
                            value={enableAcconutingData.term_deposits}
                            onChange={(event) => {
                              setEnableAccountingData({
                                ...enableAcconutingData,
                                term_deposits: event.target.value,
                              })
                            }}
                          />
                          <label for="address">Term Deposits</label>
                          {false && (
                            <div className="invalidFeedback">
                              Please enter Term Deposits.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {accountingId && (
            <div className="accountingBodyWrapper">
              <ul className="tabs dFlex flexNowrap">
                <li
                  className={`tabItem ${
                    acountingTypeActive === ACCOUNTING_TYPE.RECEIPT_PAYMENT
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    setAccountingTypeActive(ACCOUNTING_TYPE.RECEIPT_PAYMENT)
                  }
                >
                  Receipt - Payment
                </li>
                <li
                  className={`tabItem ${
                    acountingTypeActive === ACCOUNTING_TYPE.PROFIT_AND_LOSS
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    setAccountingTypeActive(ACCOUNTING_TYPE.PROFIT_AND_LOSS)
                  }
                >
                  Profit and Loss
                </li>
                <li
                  className={`tabItem ${
                    acountingTypeActive === ACCOUNTING_TYPE.BALANCE_SHEET
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    setAccountingTypeActive(ACCOUNTING_TYPE.BALANCE_SHEET)
                  }
                >
                  Balance Sheet
                </li>
                <li
                  className={`tabItem ${
                    acountingTypeActive === ACCOUNTING_TYPE.VOUCHER_REPORT
                      ? 'active'
                      : ''
                  }`}
                  onClick={() =>
                    setAccountingTypeActive(ACCOUNTING_TYPE.VOUCHER_REPORT)
                  }
                >
                  Voucher Report
                </li>
              </ul>
              <div className="accountingTabsWrapper">
                {acountingTypeActive === ACCOUNTING_TYPE.VOUCHER_REPORT &&
                  vouchersData?.length > 0 && (
                    <div className="tabContent mb-4">
                      <div className="">
                        <table className="table accounting">
                          <thead>
                            <tr>
                              <td>Date</td>
                              <td width="15%">Voucher ID</td>
                              <td width="30%">Voucher Head</td>
                              <td width="12%">Created By</td>
                              <td width="12%">Dr/Payment</td>
                              <td width="12%">Cr/Received</td>
                              <td></td>
                            </tr>
                          </thead>
                          <tbody>
                            {vouchersData?.map((voucher) => {
                              return (
                                <tr
                                  onClick={() => handleVoucherClick(voucher.id)}
                                >
                                  <td className="textPrimary">
                                    {formatDate(voucher.created_at)}
                                  </td>
                                  <td className="textPrimary">
                                    {voucher.voucher_id}
                                  </td>
                                  <td className="textPrimary">
                                    {convertToTitleCase(voucher.category)}
                                  </td>
                                  <td className="textPrimary">
                                    {voucher.created_by}
                                  </td>
                                  <td className="textPrimary">
                                    {`BDT ${voucher.total_debit || 0}`}
                                  </td>
                                  <td className="textPrimary">
                                    {`BDT ${voucher.total_credit || 0}`}
                                  </td>
                                  <td>
                                    <div className="cardHeaderRight">
                                      {activeCardId === voucher.id ? (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setActiveCardId(undefined)
                                          }}
                                        >
                                          <CloseIcon />
                                        </span>
                                      ) : (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setActiveCardId(voucher.id)
                                          }}
                                        >
                                          <DotsIcon />
                                        </span>
                                      )}
                                      {activeCardId === voucher.id && (
                                        <ul
                                          className={`cardActionsWrapper ${
                                            activeCardId === voucher.id
                                              ? 'show'
                                              : 'hide'
                                          }`}
                                        >
                                          <li
                                            className="actionItem"
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              handleVoucherEdit(voucher.id)
                                            }}
                                          >
                                            Edit
                                          </li>

                                          <li
                                            className="actionItem"
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              setSelectedVoucherId(voucher.id)
                                              setDeleteVoucherPopup(true)
                                            }}
                                          >
                                            Delete
                                          </li>
                                        </ul>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })}
                            {deleteVoucherPopup && (
                              <PopupCard
                                header="Delete Voucher?"
                                body={`Do you want to delete this voucher ${selectedVoucherId}?  `}
                              >
                                <button
                                  className="btn btnPrimaryOutlined dFlex"
                                  onClick={() => setDeleteVoucherPopup(false)}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="btn btnPrimary dFlex"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleVoucherDelete(selectedVoucherId)
                                    setDeleteVoucherPopup(false)
                                  }}
                                >
                                  Delete
                                </button>
                              </PopupCard>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                {acountingTypeActive === ACCOUNTING_TYPE.RECEIPT_PAYMENT &&
                  receiptPaymentData.hasOwnProperty('total_payments') && (
                    <div className="tabContent">
                      <div className="dFlex">
                        <div className="accountingHalf">
                          <div className="tableHeading">Receipt</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** opening Balance */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Opening Balance
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.opening_balance}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Cash in A/C</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.opening_cash_in_account}`}
                                  </td>
                                </tr>
                                {/* Sub-accounts for Cash in A/C - displays individual bank account details */}
                                {receiptPaymentData.opening_cash_in_account_details && 
                                  receiptPaymentData.opening_cash_in_account_details.length > 0 &&
                                  receiptPaymentData.opening_cash_in_account_details.map((bank, index) => (
                                    <tr key={`rp-bank-detail-${index}`} className="subAccountRow">
                                      <td style={{ paddingLeft: '30px' }}>
                                        {bank.bank_name || bank.name}
                                        {bank.account_number && ` (${bank.account_number})`}
                                      </td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${bank.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                                <tr>
                                  <td>Cash-in-Hand</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.opening_cash_in_hand}`}
                                  </td>
                                </tr>
                              </>
                              {/** Liabilities */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Liabilities
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_liabilities_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.loan_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Director/Proprietor's Loan to business
                                  </td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.director_loan_to_business_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Invoice Factoring Provider</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.invoice_factoring_provider_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">Supplier's Due / Account Payable</td>
                                  <td className="textRight textPrimary" colSpan="2">
                                    {`BDT ${receiptPaymentData.supplier_due_credit}`}
                                  </td>
                                </tr>
                                {receiptPaymentData.supplier_due_credit_details &&
                                  receiptPaymentData.supplier_due_credit_details.length > 0 &&
                                  receiptPaymentData.supplier_due_credit_details.map((supplier, index) => (
                                    <tr 
                                      key={`supplier-credit-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handlePayableItemClick(supplier)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>{supplier.supplier_name || supplier.name}</td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${supplier.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                                <tr>
                                  <td>Other Loans/Due</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.other_loans_due_credit}`}
                                  </td>
                                </tr>
                              </>
                              {/** Current Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Current Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_current_assets_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Advances / Deposits</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.advances_deposits_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan to Director/Proprietor</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.loan_to_director_credit}`}
                                  </td>
                                  {/*  */}
                                </tr>
                                <tr>
                                  <td className="textPrimary">Account Receivables</td>
                                  <td className="textRight textPrimary" colSpan="2">
                                    {`BDT ${receiptPaymentData.account_receivables_credit}`}
                                  </td>
                                  {/*  */}
                                </tr>
                                {receiptPaymentData.account_receivables_credit_details &&
                                  receiptPaymentData.account_receivables_credit_details.length > 0 &&
                                  receiptPaymentData.account_receivables_credit_details.map((item, index) => (
                                    <tr 
                                      key={`receivables-credit-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handleReceivableItemClick(item)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>{item.customer_name || item.name}</td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${item.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                              </>
                              {/** Sales */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Sales
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_sales}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Pharma Product Sales</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.actual_price_of_pharma_products_sold}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Non- Pharma Product Sales</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.actual_price_of_non_pharma_products_sold}`}
                                  </td>
                                  {/*  */}
                                </tr>
                                <tr>
                                  <td>Expired Product Return Loss</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.expired_product_return_loss}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Damage/lost Loss</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.damage_lost_loss}`}
                                  </td>
                                </tr>
                              </>
                              {/** Fixed Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Fixed Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_fixed_assets_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Land & Flat/Store</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.land_and_flat_store_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Electrical/Electronic Items</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.electrical_items_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Vehicles</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.vehicles_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Furniture & Fixtures</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.furniture_and_fixtures_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Term Deposits</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.term_deposits_credit}`}
                                  </td>
                                </tr>
                              </>
                              {/** shareholder's equity */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Shareholder's Equity
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.shareholders_equity_credit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Paid up capital</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.paid_up_capital}`}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${receiptPaymentData.total_credit}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                        <div className="accountingHalf">
                          <div className="tableHeading">Payment</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** Current Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Current Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_current_assets_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Advances / Deposits</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.advances_deposits_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan to Director/Proprietor</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.loan_to_director_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">Account Receivables</td>
                                  <td className="textRight textPrimary" colSpan="2">
                                    {`BDT ${receiptPaymentData.account_receivables_debit}`}
                                  </td>
                                </tr>
                                {receiptPaymentData.account_receivables_debit_details &&
                                  receiptPaymentData.account_receivables_debit_details.length > 0 &&
                                  receiptPaymentData.account_receivables_debit_details.map((item, index) => (
                                    <tr 
                                      key={`receivables-debit-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handleReceivableItemClick(item)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>{item.customer_name || item.name}</td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${item.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                              </>
                              {/** Fixed Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Fixed Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_fixed_assets_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Land & Flat/Store</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.land_and_flat_store_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Electrical/Electronic Items</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.electrical_items_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Vehicles</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.vehicles_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Furniture & Fixtures</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.furniture_and_fixtures_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Term Deposits</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.term_deposits_debit}`}
                                  </td>
                                </tr>
                              </>
                              {/** shareholder's equity */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Shareholder's Equity
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.shareholders_equity_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Withdrawals / Dividend to Shareholders
                                  </td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.dividend_to_shareholders}`}
                                  </td>
                                </tr>
                              </>
                              {/** Liabilities */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Liabilities
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_liabilities_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.loan_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Director/Proprietor's Loan to business
                                  </td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.director_loan_to_business_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Invoice Factoring Provider</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.invoice_factoring_provider_debit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">Supplier's Due / Account Payable</td>
                                  <td className="textRight textPrimary" colSpan="2">
                                    {`BDT ${receiptPaymentData.supplier_due_debit}`}
                                  </td>
                                </tr>
                                {receiptPaymentData.supplier_due_debit_details &&
                                  receiptPaymentData.supplier_due_debit_details.length > 0 &&
                                  receiptPaymentData.supplier_due_debit_details.map((supplier, index) => (
                                    <tr 
                                      key={`supplier-debit-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handlePayableItemClick(supplier)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>{supplier.supplier_name || supplier.name}</td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${supplier.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                                <tr>
                                  <td>Other Loans/Due</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.other_loans_due_debit}`}
                                  </td>
                                </tr>
                              </>
                              {/** Purchase/ Direct Expense */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Purchase/ Direct Expense
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.total_purchase_amount}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Pharma Product Purchase</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.total_pharma_purchase}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Non-Pharma Product Purchase</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.total_non_pharma_purchase}`}
                                  </td>
                                </tr>
                              </>
                              {/** Indirect expenses */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Indirect expenses
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${receiptPaymentData.indirect_expenses}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">
                                    Salary & Allowances
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${receiptPaymentData.total_salary_expenses}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Owner's Allowance</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.owners_allowance}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Staff Salary</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.staff_salary}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Stuff Allowance</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.stuff_allowance}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Festival Bonus</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.festival_bonus}`}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="textPrimary">
                                    General Expenses
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${receiptPaymentData.total_general_expenses}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Shop/Store Rent</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.shop_store_rent}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Platform Expense</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.platform_expense}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Delivery Expense</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.delivery_expense}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Income TAX paid to govt.</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.income_tax_paid_to_govt}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>VAT paid to govt.</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.vat_paid_to_govt}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Electricity Bill</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.electricity_bill}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Water Bill</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.water_bill}`}
                                  </td>
                                </tr>

                                <tr>
                                  <td>Connectivity Bill</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.connectivity_bill}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>BCDS monthly Fee</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.bcds_monthly_fee}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Entertainment</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.entertainment}`}
                                  </td>
                                </tr>

                                <tr>
                                  <td>Travel / Conveyance</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.travel_conveyance}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Stationary / Computer Accessories</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.stationary_computer_accessories}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Licencing & renewal fee</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.licencing_renewal_fee}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Expired Product Return Loss</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.expired_product_return_loss}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Damage/lost Loss</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.damage_lost_loss}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Depreciation</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.depreciation}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>POS machine charge</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.pos_machine_charge}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Interest Expense</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.interest_expense}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Bank charges</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.bank_charges}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Legal Charge & Fees</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.legal_charge_fees}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Audit and Tax Consultancy</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.audit_and_tax_consultancy}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Marketing/Advertising Expenses</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.marketing_advertising_expenses}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Miscellaneous</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${receiptPaymentData.miscellaneous}`}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total Payments
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${receiptPaymentData.total_payments}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Closing Balance
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${receiptPaymentData.closing_balance}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${receiptPaymentData.total_debit}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                {acountingTypeActive === ACCOUNTING_TYPE.PROFIT_AND_LOSS &&
                  profitLossData?.hasOwnProperty('debit_total') && (
                    <div className="tabContent">
                      <div className="dFlex">
                        <div className="accountingHalf">
                          <div className="tableHeading">Debit/Payments</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Opening Stock (Inventory)
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.total_opening_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.opening_pharma_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.opening_non_pharma_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Purchase Account
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.total_purchase_amount}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.total_pharma_purchase}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.total_non_pharma_purchase}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Cost of Produts Sold (COPS)
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.cost_of_products_sold}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.cost_of_pharma_products_sold}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.cost_of_non_pharma_products_sold}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Indirect Expenses
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.indirect_expenses}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Salary & Allowances</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.salary_allowances}`}
                                </td>
                              </tr>
                              <tr>
                                <td>General Expenses</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.general_expenses}`}
                                </td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${profitLossData.debit_total}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                        <div className="accountingHalf">
                          <div className="tableHeading">Credits/Sales</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Sales Account
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.sales_account}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.actual_price_of_pharma_products_sold}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.actual_price_of_non_pharma_products_sold}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Closing Stock (Inventory)
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.total_closing_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.closing_pharma_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.closing_non_pharma_stock}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Gross Profit
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.gross_profit}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.pharma_product_profit}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Non-Pharma Product</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.non_pharma_product_profit}`}
                                </td>
                              </tr>
                              <tr>
                                <td>Others</td>
                                <td className="textRight" colSpan="2">
                                  {`BDT ${profitLossData.gross_profit_others || 0}`}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan="2" className="textBold primary">
                                  Net Profit / Loss
                                </td>
                                <td className="textBold primary" colSpan="2">
                                  {`BDT ${profitLossData.net_profit_and_loss}`}
                                </td>
                              </tr>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${profitLossData.credit_total}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  )}
                {acountingTypeActive === ACCOUNTING_TYPE.BALANCE_SHEET &&
                  balanceSheetData?.hasOwnProperty('total_shareholders_equity') && (
                  <div className="tabContent">
                    <div className="previousBarWrapper dFlex flexNowrap aiCenter">
                      <div
                        className={`p-4 dFlex aiCenter cursorPointer chevron ${
                          isPresentData && 'move'
                        }`}
                        onClick={backToCurrentDataHandler}
                      >
                        <ChevronLeft />
                      </div>
                      <div className="previousBar dFlex aiCenter width100 jcSpaceBetween flexNowrap">
                        <div className="dFlex flexNowrap aiCenter">
                          {!isPresentData && <InfoPrimary />}
                          <div
                            className={`textPrimary textBold ml-2 ${
                              isPresentData && 'presentData'
                            }`}
                            onClick={() => setIsPresentData(false)}
                          >
                            View Previous Year Balance Sheet
                          </div>
                        </div>
                        {/* EDIT button hidden - users should only view Balance Sheet
                        <button
                          className={`btn btnPrimary ml-4 ${
                            isPresentData && 'hide'
                          }`}
                          onClick={() => setIsEditMode(!isEditMode)}
                        >
                          {isEditMode ? 'SAVE' : 'EDIT'}
                        </button>
                        */}
                      </div>
                    </div>
                    {isPresentData && (
                      <div className="dFlex">
                        <div className="accountingHalf">
                          <div className="tableHeading">
                            Liabilities & Owner’s Equity
                          </div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** Shareholders’ Equity */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Shareholders’ Equity
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${balanceSheetData.total_shareholders_equity}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">
                                    Paid up Capital
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.paid_up_capital}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">
                                    Retained Earning
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.retained_earning_total}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Retained Earning (Beginning Balance)</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.retained_earning}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Current year profit</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.current_year_profit}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Withdrawals / Dividend to Shareholders
                                  </td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.dividend_to_shareholders}`}
                                  </td>
                                </tr>
                              </>
                              {/** Liabilities */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Liabilities
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${balanceSheetData.liabilities_total}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.loan}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Director/Proprietor's Loan to business
                                  </td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.director_loan_to_business}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Invoice Factoring Provider</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.invoice_factoring_provider}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">Supplier's Due/Account Payable</td>
                                  <td className="textRight textPrimary" colSpan="2">
                                    {`BDT ${balanceSheetData.supplier_due}`}
                                  </td>
                                </tr>
                                {/* Sub-accounts for Account Payable (Supplier's Due) */}
                                {balanceSheetData.supplier_due_details && 
                                  balanceSheetData.supplier_due_details.length > 0 &&
                                  balanceSheetData.supplier_due_details.map((item, index) => (
                                    <tr 
                                      key={`ap-detail-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handlePayableItemClick(item)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>
                                        {item.supplier_name || item.name}
                                      </td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${item.amount}`}
                                      </td>
                                    </tr>
                                  ))
                                }
                                <tr>
                                  <td>Other Loans/Due</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.other_loans_due}`}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${balanceSheetData.total_liabilities}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                        <div className="accountingHalf">
                          <div className="tableHeading">Assets</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td
                                  width="95%"
                                  colSpan="2"
                                  className="textBold"
                                >
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** Current Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Current Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${balanceSheetData.total_current_assets}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">Cash in Hand</td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.cash_in_hand}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">Cash in Bank</td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.cash_in_account}`}
                                  </td>
                                </tr>
                                {/* Sub-accounts for Cash in Bank - displays individual bank account details */}
                                {balanceSheetData.cash_in_account_details && 
                                  balanceSheetData.cash_in_account_details.length > 0 &&
                                  balanceSheetData.cash_in_account_details.map((bank, index) => (
                                    <tr 
                                      key={`bank-detail-${index}`} 
                                      className="subAccountRow"
                                    >
                                      <td style={{ paddingLeft: '30px' }}>
                                        {bank.bank_name || bank.name}
                                        {bank.account_number && ` (${bank.account_number})`}
                                      </td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${bank.amount}`}
                                      </td>
                                    </tr>
                                  ))}
                                <tr>
                                  <td className=" textPrimary">Inventory</td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.total_inventory}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Pharma products</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.pharma_products}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Non-Pharma products</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.non_pharma_products}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Advances / Deposits
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.advances_deposits}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Loan to Director/Proprietor
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.loan_to_director}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Account Receivables
                                  </td>
                                  <td
                                    className="textRight textPrimary"
                                    colSpan="2"
                                  >
                                    {`BDT ${balanceSheetData.account_receivables}`}
                                  </td>
                                </tr>
                                {/* Sub-accounts for Account Receivables - displayed directly like Supplier's Due */}
                                {balanceSheetData.account_receivables_details && 
                                  balanceSheetData.account_receivables_details.length > 0 &&
                                  balanceSheetData.account_receivables_details.map((item, index) => (
                                    <tr 
                                      key={`ar-detail-${index}`} 
                                      className="subAccountRow clickableRow"
                                      onClick={() => handleReceivableItemClick(item)}
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <td style={{ paddingLeft: '30px' }}>
                                        {item.customer_name || item.name}
                                      </td>
                                      <td className="textRight" colSpan="2">
                                        {`BDT ${item.amount}`}
                                      </td>
                                    </tr>
                                  ))
                                }
                              </>

                              {/** Fixed Assets */}
                              <>
                                <tr>
                                  <td colSpan="2" className="textBold primary">
                                    Fixed Assets
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT ${balanceSheetData.total_fixed_assets}`}
                                  </td>
                                </tr>
                                {/* <tr>
                                                                    <td>
                                                                        Shareholder's
                                                                        Equity
                                                                    </td>
                                                                    <td className="textRight" rowSpan='2'>
                                                                        {`BDT ${receiptPaymentData.indirect_expenses}`}
                                                                    </td>
                                                                    
                                                                </tr> */}
                                <tr>
                                  <td>Land & Flat/Store</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.land_and_flat_store}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Electrical/Electronic Items</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.electrical_items}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Vehicles</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.vehicles}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Furniture & Fixtures</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.furniture_and_fixtures}`}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Term Deposits</td>
                                  <td className="textRight" colSpan="2">
                                    {`BDT ${balanceSheetData.term_deposits}`}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                            <tfoot>
                              <tr>
                                <td colSpan="2" className="textBold">
                                  Total
                                </td>
                                <td className="textRight textBold">
                                  {`BDT ${balanceSheetData.total_assets}`}
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    )}
                    {!isPresentData && (
                      <div className="dFlex">
                        <div className="accountingHalf">
                          <div className="tableHeading">
                            Liabilities & Owner's Equity
                          </div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td width="95%" className="textBold">
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** Shareholders’ Equity */}
                              <>
                                <tr>
                                  <td className="textBold primary">
                                    Shareholders’ Equity
                                  </td>
                                  <td className="textBold primary">
                                    {`BDT 0`}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="textPrimary">
                                    Paid up Capital
                                  </td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Retained Earning (Beginning Balance)</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                              </>
                              {/** Liabilities */}
                              <>
                                <tr>
                                  <td className="textBold primary">
                                    Opening Balance of Liabilities
                                  </td>
                                  <td className="textBold primary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Loan</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Director/Proprietor's Loan to business
                                  </td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Invoice Factoring Provider</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Supplier's Due/Account Payable</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Other Loans/Due</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                          </table>
                        </div>
                        <div className={`accountingHalf ${isMobile && 'mt-5'}`}>
                          <div className="tableHeading">Assets</div>
                          <table className="table accounting">
                            <thead>
                              <tr>
                                <td width="95%" className="textBold">
                                  Description
                                </td>
                                <td width="5%" className="textRight textBold">
                                  Total
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {/** Current Assets */}
                              <>
                                <tr>
                                  <td className="textBold primary">
                                    Opening Balance of Current Asset
                                  </td>
                                  <td className="textBold primary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">Cash in Hand</td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">Cash in Bank</td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">Inventory</td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Pharma products</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Non-Pharma products</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Advances & Deposits
                                  </td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Loan to Director/Proprietor
                                  </td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className=" textPrimary">
                                    Account Receivables
                                  </td>
                                  <td className="textRight textPrimary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                              </>

                              {/** Fixed Assets */}
                              <>
                                <tr>
                                  <td className="textBold primary">
                                    Opening Balance of Fixed Assets
                                  </td>
                                  <td className="textBold primary">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Land & Flat/Store</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Electrical/Electronic Items</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Vehicles</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Furniture & Fixtures</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Term Deposits</td>
                                  <td className="textRight">
                                    {isEditMode ? (
                                      <div className="formGroup">
                                        <input
                                          type="text"
                                          className="formControl form-sm"
                                        />
                                      </div>
                                    ) : (
                                      `BDT 0`
                                    )}
                                  </td>
                                </tr>
                              </>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      {isAddAccountingActive && (
        <AddAccounting
          accountingId={accountingId}
          onCancel={() => {
            getVouchersData()
            setIsAddAccountingActive(false)
          }}
          isEditVoucher={editVoucher}
          vouchersDetailsData={vouchersDetailsData}
          voucherViewOnlyId={voucherViewOnlyId}
          branchData={activeBranchData}
          loginData={props.loginData}
        />
      )}

      {/* Invoice Popup for Account Receivable (Due Receive from Customers) */}
      {showReceivableInvoicePopup && (
        <>
          <div className="bgmask" onClick={closeReceivableInvoicePopup}></div>
          <div className="invoicePopupWrap">
            <div className="invoicePopup">
              <div className="invoicePopupHeader">
                <span className="headerTitle">Due Sales Invoices - {selectedReceivableItem?.customer_name || selectedReceivableItem?.name}</span>
                <span className="closeBtn" onClick={closeReceivableInvoicePopup}>
                  <CloseIcon />
                </span>
              </div>
              <div className="invoicePopupBody">
                {dueReceiveLoading ? (
                  <div className="noData">Loading invoices...</div>
                ) : dueReceivableInvoices.length === 0 ? (
                  <div className="noData">No due invoices found</div>
                ) : (
                  <table className="invoiceTable">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Due Date</th>
                        <th>Due Time</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dueReceivableInvoices.map((invoice, index) => (
                        <tr key={`receivable-invoice-${index}`}>
                          <td>{invoice.invoice_number}</td>
                          <td>{invoice.due_date}</td>
                          <td>{invoice.due_time}</td>
                          <td className="amount">BDT {invoice.total_amount}</td>
                          <td className="action">
                            {invoice.payment_status === 'RECEIVED_ONLINE' ? (
                              <span className="statusBadge paid">Received Online</span>
                            ) : invoice.payment_status === 'RECEIVED_VOUCHER' ? (
                              <span className="statusBadge paid">Received (Voucher)</span>
                            ) : (
                              <button 
                                className="btn btnPrimary btnSm"
                                onClick={() => handleDueReceiveClick(invoice)}
                              >
                                Due Receive
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="invoicePopupFooter">
                <button 
                  className="btn btnPrimaryOutlined"
                  onClick={closeReceivableInvoicePopup}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Invoice Popup for Account Payable (Due Pay to Suppliers) */}
      {showPayableInvoicePopup && (
        <>
          <div className="bgmask" onClick={closePayableInvoicePopup}></div>
          <div className="invoicePopupWrap">
            <div className="invoicePopup">
              <div className="invoicePopupHeader">
                <span className="headerTitle">Due Purchase Invoices - {selectedPayableItem?.supplier_name || selectedPayableItem?.name}</span>
                <span className="closeBtn" onClick={closePayableInvoicePopup}>
                  <CloseIcon />
                </span>
              </div>
              <div className="invoicePopupBody">
                {duePayLoading ? (
                  <div className="noData">Loading invoices...</div>
                ) : duePayableInvoices.length === 0 ? (
                  <div className="noData">No due invoices found</div>
                ) : (
                  <table className="invoiceTable">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Due Date</th>
                        <th>Due Time</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {duePayableInvoices.map((invoice, index) => (
                        <tr key={`payable-invoice-${index}`}>
                          <td>{invoice.invoice_number}</td>
                          <td>{invoice.due_date}</td>
                          <td>{invoice.due_time}</td>
                          <td className="amount">BDT {invoice.total_amount}</td>
                          <td className="action">
                            {invoice.payment_status === 'PAID_ONLINE' ? (
                              <span className="statusBadge paid">Paid Online</span>
                            ) : invoice.payment_status === 'PAID_VOUCHER' ? (
                              <span className="statusBadge paid">Paid (Voucher)</span>
                            ) : (
                              <button 
                                className="btn btnPrimary btnSm"
                                onClick={() => handleDuePayClick(invoice)}
                              >
                                Due Pay
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="invoicePopupFooter">
                <button 
                  className="btn btnPrimaryOutlined"
                  onClick={closePayableInvoicePopup}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Due Receive Options Popup (Account Receivable) */}
      {showDueReceiveOptionsPopup && (
        <>
          <div className="bgmask" onClick={closeDueReceiveOptionsPopup}></div>
          <div className="duePayPopupWrap">
            <div className="duePayPopup">
              <div className="duePayPopupHeader">
                <span className="headerTitle">Select Receive Method</span>
                <span className="closeBtn" onClick={closeDueReceiveOptionsPopup}>
                  <CloseIcon />
                </span>
              </div>
              <div className="duePayPopupBody">
                <div className="invoiceInfo">
                  <div className="infoRow">
                    <span className="label">Invoice:</span>
                    <span className="value">{selectedReceivableInvoice?.invoice_number}</span>
                  </div>
                  <div className="infoRow">
                    <span className="label">Customer:</span>
                    <span className="value">{selectedReceivableItem?.customer_name || selectedReceivableItem?.name || selectedReceivableInvoice?.customer_name || '-'}</span>
                  </div>
                  <div className="infoRow">
                    <span className="label">Amount:</span>
                    <span className="value primary">BDT {selectedReceivableInvoice?.total_amount}</span>
                  </div>
                </div>
                <div className="paymentOptions">
                  <button 
                    className="btn btnPrimary"
                    onClick={handleReceiveOnline}
                    disabled={dueReceiveLoading}
                  >
                    {dueReceiveLoading ? 'Processing...' : 'Receive Online'}
                  </button>
                  <button 
                    className="btn btnPrimaryOutlined"
                    onClick={handleVoucherReceive}
                  >
                    Voucher Receive
                  </button>
                </div>
              </div>
              <div className="duePayPopupFooter">
                <button 
                  className="btn btnSecondary"
                  onClick={closeDueReceiveOptionsPopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Due Pay Options Popup (Account Payable) */}
      {showDuePayOptionsPopup && (
        <>
          <div className="bgmask" onClick={closeDuePayOptionsPopup}></div>
          <div className="duePayPopupWrap">
            <div className="duePayPopup">
              <div className="duePayPopupHeader">
                <span className="headerTitle">Select Payment Method</span>
                <span className="closeBtn" onClick={closeDuePayOptionsPopup}>
                  <CloseIcon />
                </span>
              </div>
              <div className="duePayPopupBody">
                <div className="invoiceInfo">
                  <div className="infoRow">
                    <span className="label">Invoice:</span>
                    <span className="value">{selectedPayableInvoice?.invoice_number}</span>
                  </div>
                  <div className="infoRow">
                    <span className="label">Supplier:</span>
                    <span className="value">{selectedPayableItem?.supplier_name || selectedPayableItem?.name || selectedPayableInvoice?.supplier_name || '-'}</span>
                  </div>
                  <div className="infoRow">
                    <span className="label">Amount:</span>
                    <span className="value primary">BDT {selectedPayableInvoice?.total_amount}</span>
                  </div>
                </div>
                <div className="paymentOptions">
                  <button 
                    className="btn btnPrimary"
                    onClick={handlePayOnline}
                    disabled={duePayLoading}
                  >
                    {duePayLoading ? 'Processing...' : 'Pay Online'}
                  </button>
                  <button 
                    className="btn btnPrimaryOutlined"
                    onClick={handleVoucherPayment}
                  >
                    Voucher Payment
                  </button>
                </div>
              </div>
              <div className="duePayPopupFooter">
                <button 
                  className="btn btnSecondary"
                  onClick={closeDuePayOptionsPopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    loginData: state.loginDataReducer?.loginData,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Accounting)
